import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import BaseElement from '../../BaseElement/BaseElement';
import map from 'lodash/map';
import omit from 'lodash/omit';
import assign from 'lodash/assign';
import {findDOMNode} from 'react-dom';
import _ from 'lodash';
import {buildInteractiveElementsList} from 'crazyEditor/core/elements/utils/commonElementMethods';
import {VERTICAL_TAB_TRANSITION_DURATION} from 'crazyEditor/core/constants/editorConstants';
import RichTextElement from '../../RichTextElement/RichTextElement';
import RichTextElementProps from '../../RichTextElement/RichTextElementProps';
import { PADDING_PROP_NAMES } from 'crazyEditor/core/constants/panelConstants';
import update from 'react-addons-update';
import InlineStyle from 'crazyEditor/components/Elements/common/InlineStyle';

const TOTAL_ELEMENT_HEIGHT = 480;
const CONTENT_VERTICAL_PADDING = 5;

require('./GlobalStyles/VerticalTabsElement.scss');
const classNamePrefix = 'cl-tabs-el';

function getPrefix(className) {
  return `${classNamePrefix}-${className}`;
}

const styles = {
  tabChild: {
    transitionProperty: 'all',
    transitionDuration: `${VERTICAL_TAB_TRANSITION_DURATION}ms`,
    transitionTimingFunction: 'ease-in-out',
    position: 'relative',
    width: '100%',
  },
};

function getCSS(uId, numItems) {
  const CSS = [];
  const contentHeight = TOTAL_ELEMENT_HEIGHT - (CONTENT_VERTICAL_PADDING * 2) - (50 * numItems);
  for (let i = 1; i <= numItems; i++) {
    const tabsId = `${classNamePrefix}-tabs${i}-${uId}`;
    CSS.push(`
        #${tabsId}:checked + .${classNamePrefix}-label {
            background-color: #e6e6e6;
        }

        #${tabsId}:checked ~ .${classNamePrefix}-content${i}-${uId} {
          flex-grow: 1;
        }
        #${tabsId}:not(:checked) ~ .${classNamePrefix}-content${i}-${uId} {
          padding-top: 0px!important;
          padding-bottom: 0px!important;
          overflow-y: hidden!important;
        }
      `);
  }

  return CSS.join('').replace(/\s{2,}/g, '');
}

export default class VerticalTabsElement extends PureComponent {
  componentWillMount() {
    this.uniqueId = `u_${this.props.id}`;
  }

  componentDidMount = () => {
    this.childrenOffset = _.get(findDOMNode(this.refs.labelOffsetPlaceholder), 'clientHeight');
    this.refreshInteractiveElementsList(null);
  };

  componentDidUpdate() {
    this.refreshInteractiveElementsList(null);
  }

  // get styles of elements that have a cursor: pointer. in tabs those are the tab headers
  getInteractiveElements = () => {
    return this.interactiveElements;
  };

  refreshInteractiveElementsList = (onComplete) => {
    let interactiveElements = [];
    const wrapper = findDOMNode(this.refs.tabElement);
    if (wrapper) {
      interactiveElements = buildInteractiveElementsList(wrapper);
      if (interactiveElements.length > 0) {
        this.interactiveElements = interactiveElements;
        if (onComplete) {
          onComplete();
        }
      }
    }
  };

  render() {
    const { tabNames, children, compProps, childrenProps, fontSizeInPercentFromDesktop} = this.props.data;
    const parentType = this.props.type;
    const containerCompProps = omit(this.props.compProps, ...PADDING_PROP_NAMES);
    const tabStyles = omit(compProps, ['zIndex']);
    const tabContentBackgroundColor = _.get(childrenProps, 'compProps.backgroundColor', 'white');

    tabStyles.backgroundColor = containerCompProps.backgroundColor;
    return (
      <BaseElement style={{overflow: 'hidden'}} {...this.props} compProps={omit(containerCompProps, 'backgroundColor', 'backgroundImage')} ref="tabElement">
        <InlineStyle css={getCSS(this.uniqueId, tabNames.length)} />
        <div className={getPrefix('wrapper')} style={{display: 'flex', flexDirection: 'column', height: '100%'}}>
          {map(tabNames, (tabName, index) => {
            const ind = index + 1;
            let tabChild = children[index];
            if (fontSizeInPercentFromDesktop) {
              tabChild = update(tabChild, {parentType: {$set: parentType}, data: {fontSizeInPercentFromDesktop: {$set: fontSizeInPercentFromDesktop}}});
            }
            const tabChildStyles = omit(
              assign({}, tabChild ? tabChild.compProps : {}, styles.tabChild, {backgroundColor: tabContentBackgroundColor}),
              ['zIndex', 'boxShadow', 'WebkitBoxShadow', 'border', 'borderRadius', 'height', 'fontSize']
            );
            const tabsId = getPrefix(`tabs${ind}-${this.uniqueId}`);
            return [
              <input key="input" id={tabsId} type="radio" name={getPrefix(`tabs-${this.uniqueId}`)} defaultChecked={ind === 1}/>,
              <label key="label" htmlFor={tabsId}
                     className={getPrefix('label')}
                     style={tabStyles}>{tabName.replace('&amp;', '&')}</label>,
              tabChild && React.createElement(RichTextElement.elementClass, {
                ...tabChild,
                id: `mobile_${tabChild.id}`,
                style: tabChildStyles,
                definitionProps: RichTextElementProps,
                key: `tabChild${ind}`,
                className: `${getPrefix('content')} ${getPrefix(`content${ind}-${this.uniqueId}`)}`
              })
            ];
          })
          }
        </div>
      </BaseElement>
    );
  }
}

VerticalTabsElement.propTypes = {
  id: PropTypes.string.isRequired,
  layout: PropTypes.shape({
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired
  })
};